import { render, staticRenderFns } from "./SpeakerOnIcon.vue?vue&type=template&id=06dbda79&scoped=true&"
import script from "./SpeakerOnIcon.vue?vue&type=script&lang=js&"
export * from "./SpeakerOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbda79",
  null
  
)

export default component.exports